const CAPTCHA_KEY = process.env.VUE_APP_CAPTCHA_KEY;

const getCaptchaToken = () => new Promise((resolve) => {
    window.grecaptcha.enterprise.ready(function () {
        window.grecaptcha.enterprise.execute(CAPTCHA_KEY, { action: "login" })
            .then((token) => resolve({ token, CAPTCHA_KEY }));
    });
});

export {
    CAPTCHA_KEY,
    getCaptchaToken
};
